<template>
  <div class="login">
    <div class="Slogan">
      <img src="../../assets/img/logo.png" alt="掌大师">
      <div class="SloganText">
        <h2 class="Slogan-head-title">掌大师ERP管理</h2>
        <h2 class="Slogan-head-text">帮您轻松管理每一天</h2>
      </div>
    </div>
    <div class="form-content">
        <!--<p class="form-content-title">账号登录</p>-->
        <div class="Steps">
           <span>1</span> 输入手机号码验证
           <Icon type="ios-arrow-forward" />
           <span class="linkFor">2</span> <i class="linkFor"> 填写个人信息</i>
        </div>
        <Form class="form-info" >
          <p class="reg_title">账号登录</p>
          <FormItem class="FormItem">
            <img src="../../assets/img/reg_tel.png">
            <input type="text" class="form-input" v-model.trim="formInline.account"  placeholder="输入手机号">
          </FormItem>
          <!--验证手机号码-->
          <FormItem class="FormItem">
            <div class="drag" ref="dragDiv">
              <div class="drag_bg"></div>
              <div class="drag_text">{{confirmWords}}</div>
              <div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;"></div>
            </div>
          </FormItem>
          <!--验证码-->
          <FormItem class="FormItem">
            <img src="../../assets/img/reg_code.png" style="top: 14px;">
            <input type="text" class="form-input" v-model.trim="formInline.telCode" placeholder="输入手机号">
            <span class="getCode" v-if="showsTime" @click="getCode()">获取验证码</span>
            <span class="getCode" v-else >{{time}}</span>
          </FormItem>
          <FormItem style="margin-bottom: 10px">
            <Button size="large" type="primary" class="submit-form" @click="submitForm()" :disabled="isClicked">填 写 信 息 <Icon type="ios-arrow-forward" style="font-size: 24px" /></Button>
          </FormItem>
          <FormItem style="margin-bottom: 10px">
            <p style="font-size: 14px; color: #2d8cf0"><router-link to="/login">已有账号，去登陆 </router-link><Icon type="ios-arrow-forward" /></p>
          </FormItem>
        </Form>

    </div>
    <div class="Company">
      <p>客服电话:400-801-6580</p>
      <p>公司官网:www.tangyingchina.com</p>
      <p>登录即代表同意《掌大师用户服务协议》</p>
    </div>
  </div>
</template>
<script>
  export default {
    components: {},
    data () {
      return {
        beginClientX:0,           /*距离屏幕左端距离*/
        mouseMoveStata:false,     /*触发拖动状态  判断*/
        maxwidth:'',               /*拖动最大宽度，依据滑块宽度算出来的*/
        confirmWords:'拖动滑块验证',   /*滑块文字*/
        confirmSuccess:false,           /*验证成功判断*/
        isClicked:true,
        time:'获取验证码',
        showsTime:true,
        formInline: {
          account: '',
          telCode:'',

        },
      }
    },
    mounted: function() {
      //DOM更新完后再请求数据
      this.$nextTick(function() {
        this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
        document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
        document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn)
      });
    },
    created: function() {
      //DOM更新完之前请求数据
    },
    methods: {
      //判断手机号码是否已经注册
      isRegisterAt(){
        var tel = this.formInline.account
        if(tel==''){
          this.$Message.info('请填写手机号');
          return;
        }
        var telTest = /^(13[0-9]|15[0-9]|14[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
        if (!telTest.test(tel)) {
          this.$Message.info('请输入正确的手机号码');
          return
        }
        this.$Api.isRegister({
          account:this.formInline.account,
        }).then(res => {
          if( res.code == 200 && res.data==1 ){
            this.$Message.info('该手机号已经注册,请直接登录');
            this.isClicked=false
            this.$router.push('/login')
          }else if( res.code == 400 ){
            this.$Message.info(res.msg);
          }
        });
      },
      //获取验证码
      getCode(){
        var tel = this.formInline.account
        if(tel==''){
          this.$Message.info('请填写手机号');
          return;
        }
        var telTest = /^(13[0-9]|15[0-9]|14[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
        if (!telTest.test(tel)) {
          this.$Message.info('请输入正确的手机号码');
          return
        }
        if (this.confirmWords!='验证通过' ) {
          this.$Message.info('请完成拖动验证');
          return
        }

        this.$Api.sendSMS({
          phoneNum:this.formInline.account,
        }).then(res => {
          if( res.code == 200 ){
            this.$Message.info('发送成功');
            sessionStorage.setItem('regCode',res.data.code)
            sessionStorage.setItem('regTel',this.formInline.account)
            this.showsTime=false
            var times = 60
            var timer = setInterval( ()=> {
              times--
              if(times<=0){
                clearInterval(timer)
                this.showsTime=true
              }else {
                this.time=times+'s后重发'
              }
            },1000)

          }else if( res.code == 400 ){
            this.$Message.info(res.msg);
          }
        });

      },
      //填写信息
      submitForm() {
        var tel = this.formInline.account
        var telCode = this.formInline.telCode
        if(tel==''){
          this.$Message.info('请填写手机号');
          return;
        }
        var telTest = /^(13[0-9]|15[0-9]|14[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
        if (!telTest.test(tel)) {
          this.$Message.info('请输入正确的手机号码');
          return
        }
        if(telCode==''){
          this.$Message.info('验证不能为空');
          return;
        }
        var getSessionCode = sessionStorage.getItem('regCode')
        if(telCode!=getSessionCode){
          this.$Message.info('验证有误');
          return;
        }
        this.$router.push('/regEditMsg')
      },
      mousedownFn:function (e) {
        if(!this.confirmSuccess){
          e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
          this.mouseMoveStata = true;
          this.beginClientX = e.clientX;
        }
      },
      //mousedoen 事件
      successFunction(){
          this.confirmSuccess = true
          this.confirmWords = '验证通过';
          if(window.addEventListener){
            document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFn);
            document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFn);
          }else {
            document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
          }
          document.getElementsByClassName('drag_text')[0].style.color = '#fff'
          document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
          document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
          this.isClicked=false
          this.isRegisterAt()
      },
      //验证成功函数
      mouseMoveFn(e){
        if(this.mouseMoveStata){
          let width = e.clientX - this.beginClientX;
          if(width>0 && width<=this.maxwidth){
            document.getElementsByClassName('handler')[0].style.left = width + 'px';
            document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
          }else if(width>this.maxwidth){
            this.successFunction();
          }
        }
      },
      //mousemove事件
      moseUpFn(e){
        this.mouseMoveStata = false;
        var width = e.clientX - this.beginClientX;
        if(width<this.maxwidth){
          document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
          document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
        }
      }
    }
  }
</script>


<style  lang="scss" scoped>
  .login{
    width: 100%;
    height: 100%;
    background: url("../../assets/img/loginbg.png") no-repeat;
    background-size: 90% 70%;
    position: relative;
  }
  .Slogan{
    width: 500px;
    position: absolute;
    top: 40%;
    left: 200px;
    color: #ffffff;
    font-weight: normal;
    img{
      display: inline-block;
      margin-right: 20px;
    }
    .SloganText{
      display: inline-block;
      position: relative;
      top: -5px;
      .Slogan-head-title{
        font-size: 36px;
      }
      .Slogan-head-text{
        font-size: 32px;
      }
    }
  }
  .form-content{
    position: absolute;
    right: 51px;
    top: 50%;
    margin-top: -233px;
    .form-content-title{
      height: 56px;
      padding-left: 20px;
      font-family: SimHei;
      font-size: 34px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #fefeff;
    }
    .form-info{
      .reg_title{
        font-size: 20px;
        padding-bottom: 10px;
        color: #4c7cef;
      }
      width: 490px;
      background-color: #ffffff;
      box-shadow: 0px 10px 40px 0px
      rgba(61, 111, 226, 0.4);
      border-radius: 40px;
      padding:50px 50px 80px;
      .FormItem{
        height: 40px;
        position: relative;
        img{
          position: absolute;
          left: 10px;
          top: 8px;
          width: 18px;
        }
        .form-input{
          width: 100%;
          height:40px;
          font-size: 14px;
          padding-left: 40px;
          border: 1px solid #d9d9d9;
        }

      }
    }
  }
  .forget{
    font-size: 18px;
  }
  .submit-form{
    width: 390px;
    height: 40px;
  }

  .Company{
    position: absolute;
    bottom: 60px;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0px;
    color: #3d6fe0;
    line-height: 30px;
    width: 590px;
    text-align: center;
  }
  .getCode{
    position: absolute;
    right: 5px;
    top: 10px;
    cursor: pointer;
    display: block;
    width: 122px;
    height: 23px;
    text-align: center;
    line-height: 23px;
    font-size: 14px;
    color: #608efc;
    border-left: 1px solid #cccccc;
    padding-left: 10px;
  }

  /*==========
* 进度条 *
===========*/
  .Steps{
    font-size: 18px;

    padding-bottom: 10px;
    span{
      display: inline-block;
      width: 35px;
      height: 35px;
      background-color: #ffffff;
      border-radius: 50%;
      line-height: 35px;
      text-align: center;
      color: #4675e1;
    }
    .linkFor{
      opacity: 0.5;
      font-style: normal;
    }

  }



  /*==========
  * 滑块验证 *
  ===========*/
  .drag{
    position: relative;
    background-color: #e8e8e8;
    width: 100%;
    height: 36px;
    line-height: 36px;
    text-align: center;
  }
  .handler{
    width: 40px;
    height: 36px;
    border: 1px solid #ccc;
    cursor: move;
  }
  .handler_bg{
    background: #fff url("../../assets/img/rightg.png") no-repeat 0 3px;
    background-size: 80%;
  }
  .handler_ok_bg{
    background: #fff url("../../assets/img/ok.png") no-repeat 3px 7px;
    background-size: 80%;
  }
  .drag_bg{
    background-color: #4374df;
    height: 36px;
    width: 0px;
    opacity: .5;
  }
  .drag_text{
    position: absolute;
    top: 0px;
    width: 100%;text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select:none;
    -ms-user-select:none;
  }
</style>